import React from 'react'
import WriteOffActFilesBlock from './WriteOffActFilesBlock'

const WriteOffActFiles = ({ writeOffActId }) => {
  return (
    <div>
        <h4>Файли</h4>

        <WriteOffActFilesBlock 
            name='Акт'
            tableOwnerId={writeOffActId}
            type='act'
        />

    </div>
  )
}

export default WriteOffActFiles